<template>
    <div>
        <div class="solution">
            <GridComponent />
        </div>
    </div>
</template>

<script>
import GridComponent  from '@/components/GridComponent.vue'

export default {
    name: 'SolutionCenter',
    components: {
        GridComponent 
    },
        
}
</script>

<style scoped>
.solution div img {
    width: 100%;
}
.solution h3 {
    padding: 20px;
}
.solution a {
    font-size: 14px;
    color: #1e7962;
    padding: 0 20px 20px;
    display: block;
    text-decoration: none;
}
</style>
